var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faChevronDown, faChevronUp, faXmark, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { FormSettingsContext, addComponent, createStateSnapshot, defaultSettings, findParent, moveDownComponent, moveFirstComponent, moveLastComponent, moveUpComponent, removeComponent, scrollToEl, updateLayoutComponent, } from "./utils";
import copy from "fast-copy";
export var FormComponentButtons = function (_a) {
    var parentId = _a.parentId, meta = _a.meta, isSelected = _a.isSelected, isLayout = _a.isLayout;
    var _b = useContext(FormSettingsContext), settings = _b.settings, editedSettings = _b.editedSettings;
    var _c = useState(true), isDisabled = _c[0], setIsDisabled = _c[1];
    var setSelectedToNull = function (e) {
        e.stopPropagation();
        editedSettings(__assign(__assign({}, defaultSettings), { newLayout: settings.newLayout, clipBoard: settings.clipBoard, undoStack: settings.undoStack, redoStack: settings.redoStack }));
    };
    var copyEditedValueFromProps = function () {
        var editedValue = copy(parentId);
        var s = editedValue.settings || {};
        var styles = s.styles || {};
        var spacing = styles.spacing || {};
        var color = styles.color || {};
        var sizing = styles.sizing || {};
        styles.color = color;
        styles.spacing = spacing;
        styles.sizing = sizing;
        s.styles = styles;
        editedValue.settings = s;
        return editedValue;
    };
    /**
     * Select parent of layout component
     * @param {*} e event
     */
    var componentSelectParent = function (e) {
        e.stopPropagation();
        if (parentId === "" || parentId === null) {
            return;
        }
        var p = findParent(settings.newLayout.layout && settings.newLayout.layout, parentId.id);
        var el = document.getElementById(parentId.id);
        el && scrollToEl(el);
        editedSettings(__assign(__assign({}, settings), { target: parentId.id, type: parentId.type, component: parentId.components, selected: parentId.id, parentId: p, currentComponent: copyEditedValueFromProps() }));
    };
    /**
     * Add new layout component
     * @param {*} e event
     */
    var requestAddComponent = function (e) {
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        editedSettings(__assign(__assign({}, settings), { isNew: true }));
    };
    /**
     * Delete layout component
     * @param {*} e event
     */
    var remove = function (e) {
        var _a;
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var runDelete = removeComponent(Object.values(settings.newLayout), settings.target);
        var deleted = runDelete[0];
        // Ajouter un layout vide lorsqu'il n'existe plus de composant pour le layout view
        if ((deleted === null || deleted === void 0 ? void 0 : deleted.components) && ((_a = deleted === null || deleted === void 0 ? void 0 : deleted.components) === null || _a === void 0 ? void 0 : _a.length) === 0 && isLayout) {
            if (settings.type === "tab") {
                deleted = {
                    components: [
                        {
                            id: uuidv4(),
                            type: "tab",
                            components: [
                                {
                                    id: uuidv4(),
                                    type: "layout-rows",
                                    components: [],
                                },
                            ],
                            settings: {
                                labels: ["New tab"],
                            },
                        },
                    ],
                };
            }
            else {
                deleted = {
                    components: [
                        {
                            id: uuidv4(),
                            type: settings.currentComponent.type || settings.type,
                            components: [],
                        },
                    ],
                };
            }
        }
        var removeState = __assign(__assign({}, settings), { newLayout: { layout: deleted } });
        var after = createStateSnapshot(removeState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "REMOVE_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, removeState), { undoStack: saveUndo }));
    };
    /**
     * Move layout component to first place
     * @param {*} e event
     */
    var moveFirst = function (e) {
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var newComponent = moveFirstComponent(settings.parentId.components || [], settings.currentComponent);
        var first = updateLayoutComponent(Object.values(settings.newLayout || []), settings.parentId.id, newComponent);
        var moveFirstState = __assign(__assign({}, settings), { selected: "", newLayout: { layout: first[0] } });
        var after = createStateSnapshot(moveFirstState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "MOVE_FIRST_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, moveFirstState), { undoStack: saveUndo }));
    };
    /**
     * Move layout component to last place
     * @param {*} e event
     */
    var moveLast = function (e) {
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var newComponent = moveLastComponent(settings.parentId.components || [], settings.currentComponent);
        var modifiedLayout = updateLayoutComponent(Object.values(settings.newLayout || []), settings.parentId.id, newComponent);
        var moveLastState = __assign(__assign({}, settings), { selected: "", newLayout: { layout: modifiedLayout[0] } });
        var after = createStateSnapshot(moveLastState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "MOVE_LAST_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, moveLastState), { undoStack: saveUndo }));
    };
    /**
     * Copy layout component from a list
     * Add to clipboard
     * @param {*} e event
     */
    var uuidv4 = require("uuid").v4;
    var copyComponent = function (e) {
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        editedSettings(__assign(__assign({}, settings), { clipBoard: __assign(__assign({}, settings.currentComponent), { id: uuidv4() }) }));
    };
    /**
     * Cut layout component from a list
     * Add to clipboard
     * @param {*} e event
     */
    var cutComponent = function (e) {
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var remove = removeComponent(Object.values(settings.newLayout), settings.target);
        var cutState = __assign(__assign({}, settings), { clipBoard: __assign(__assign({}, settings.currentComponent), { id: uuidv4() }), newLayout: { layout: remove[0] } });
        var after = createStateSnapshot(cutState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "CUT_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, cutState), { undoStack: saveUndo }));
    };
    /**
     * Paste layout component from a list
     * Add to clipboard
     * @param {*} e event
     */
    var pasteComponent = function (e) {
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var newC = addComponent(Object.values(settings.newLayout || []), settings.selected, settings.clipBoard);
        var pasteState = __assign(__assign({}, settings), { clipBoard: "", newLayout: { layout: newC[0] } });
        var after = createStateSnapshot(pasteState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "PASTE_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, pasteState), { undoStack: saveUndo }));
    };
    /**
     * Move layout component to up
     * @param {*} e event
     */
    var moveUp = function (e) {
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var newComponent = moveUpComponent(settings.parentId.components || [], settings.currentComponent);
        var modifiedLayout = updateLayoutComponent(Object.values(settings.newLayout || []), settings.parentId.id, newComponent);
        var moveUpState = __assign(__assign({}, settings), { selected: "", newLayout: { layout: modifiedLayout[0] } });
        var after = createStateSnapshot(moveUpState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "MOVE_UP_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, moveUpState), { undoStack: saveUndo }));
    };
    /**
     * Move layout component to down
     * @param {*} e event
     */
    var moveDown = function (e) {
        e.stopPropagation();
        if (!settings.target) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var newComponent = moveDownComponent(settings.parentId.components || [], settings.currentComponent);
        var modifiedLayout = updateLayoutComponent(Object.values(settings.newLayout || []), settings.parentId.id, newComponent);
        var moveDownState = __assign(__assign({}, settings), { selected: "", newLayout: { layout: modifiedLayout[0] } });
        var after = createStateSnapshot(moveDownState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "MOVE_DOWN_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, moveDownState), { undoStack: saveUndo }));
    };
    useEffect(function () {
        settings.clipBoard && settings.clipBoard !== ""
            ? setIsDisabled(false)
            : setIsDisabled(true);
    }, [settings.clipBoard]);
    return (_jsx(_Fragment, { children: 
        /*(parentId.length !== "" || parentId.length !== null) &&*/
        (isSelected || settings.selected === meta.id) && (_jsxs("div", __assign({ className: "absolute top-0 right-0 z-10 p-2 transition-all duration-75 bg-gray-100 border border-gray-400 rounded-md shadow-lg" }, { children: [_jsx("button", __assign({ title: "Fermer", className: "absolute top-0 right-0 p-1", onClick: function (e) {
                        setSelectedToNull(e);
                    } }, { children: _jsx(FontAwesomeIcon, { icon: faXmark }) })), _jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("span", __assign({ className: "px-4 mx-4 text-center text-gray-900 bg-gray-200 rounded-md" }, { children: meta.type })), _jsxs("span", __assign({ className: "flex flex-row justify-start" }, { children: [_jsx("button", __assign({ title: "Modifier les param\u00E8tres du parent", className: "p-1", onClick: function (e) {
                                        componentSelectParent(e);
                                    } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" }) })) })), isLayout && (_jsx("button", __assign({ className: "p-1 ", title: "Ajouter un composant", onClick: function (e) {
                                        requestAddComponent(e);
                                    } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25V18A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z" }) })) })))] })), _jsx("span", __assign({ className: "inline-flex flex-row" }, { children: _jsxs(_Fragment, { children: [_jsx("button", __assign({ title: "D\u00E9placer en premier", className: "p-1 ", onClick: function (e) {
                                            moveFirst(e);
                                        } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: "w-5 h-5", viewBox: "0 0 20 20", fill: "currentColor" }, { children: _jsx("path", { "fill-rule": "evenodd", d: "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z", "clip-rule": "evenodd" }) })) })), _jsx("button", __assign({ title: "D\u00E9placer vers le haut", className: "p-1 ", onClick: function (e) {
                                            moveUp(e);
                                        } }, { children: _jsx(FontAwesomeIcon, { icon: faChevronUp, className: " text-gray-600" }) })), _jsx("button", __assign({ title: "D\u00E9placer vers le bas", className: "p-1 ", onClick: function (e) {
                                            moveDown(e);
                                        } }, { children: _jsx(FontAwesomeIcon, { icon: faChevronDown, className: " text-gray-600" }) })), _jsx("button", __assign({ title: "D\u00E9placer en dernier", className: "p-1 ", onClick: function (e) {
                                            moveLast(e);
                                        } }, { children: _jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: "w-5 h-5", viewBox: "0 0 20 20", fill: "currentColor" }, { children: [_jsx("path", { "fill-rule": "evenodd", d: "M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z", "clip-rule": "evenodd" }), _jsx("path", { "fill-rule": "evenodd", d: "M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z", "clip-rule": "evenodd" })] })) }))] }) })), _jsxs("span", { children: [_jsx("button", __assign({ title: "Couper", className: "p-1 ", onClick: function (e) {
                                        cutComponent(e);
                                    } }, { children: _jsx("svg", __assign({ className: "w-6 h-6", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879M12 12L9.121 9.121m0 5.758a3 3 0 10-4.243 4.243 3 3 0 004.243-4.243zm0-5.758a3 3 0 10-4.243-4.243 3 3 0 004.243 4.243z" }) })) })), _jsx("button", __assign({ title: "Copier", className: "p-1 ", onClick: function (e) {
                                        copyComponent(e);
                                    } }, { children: _jsx("svg", __assign({ className: "w-6 h-6", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" }) })) })), isLayout && (_jsx(_Fragment, { children: _jsx("button", __assign({ title: "Coller", className: "p-1 disabled:text-gray-400 ", disabled: isDisabled, onClick: function (e) {
                                            pasteComponent(e);
                                        } }, { children: _jsx("svg", __assign({ className: "w-6 h-6", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" }) })) })) }))] }), _jsx("button", __assign({ title: "Supprimer", className: "button danger flex justify-center p-1", onClick: function (e) {
                                remove(e);
                            } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-5 h-5" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" }) })) }))] }))] }))) }));
};
